<template>
  <div class="product__configurable-option__select">
    <select @change="updateCurrentStep($event)" :name="`super_attribute[${optionData.id}]`" :disabled="!checkEnabled" v-model="selectedValue">
      <option v-if="!hasSingleOption" value="" selected disabled>{{ $t('Choose your {option}', {option: optionData.label.toLowerCase()}) }}</option>
      <option
        v-for="(attributeOption, index) in attributeData"
        v-bind:key="index"
        :value="attributeOption.id"
        :disabled="!attributeOption.in_stock && !showStockNotifier"
      >
        {{ attributeOption.label }}
        <template v-if="showAdditionalPrice && productFinalPrice !== attributeOption.price">
          {{ `(${(attributeOption.price).priceFormat()})`}}
        </template>
      </option>
    </select>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';

  @Component(
    {
      name: 'catalog-product-configurable-select'
    }
  )

  export default class extends Vue {
    @Prop() private readonly optionData: object;
    @Prop() private readonly checkEnabled: boolean;
    @Prop() private readonly step: number;
    @Prop() private readonly showStockNotifier: boolean;

    private selectedValue: number | string = '';
    private hasSingleOption: boolean = false;
    private attributeData = [];

    private async updateCurrentStep(e): Promise<void> {
      await this.$store.dispatch('CatalogConfigurableProduct/setSelectedOption', {attributeId: this.optionData['id'], attributeCode: this.optionData['code'], selectedValue: e.target.value});
      await this.$store.dispatch('CatalogConfigurableProduct/updateStep', (this.step + 1));
      if (this.$store.getters['CatalogConfigurableProduct/virtualProducts'].length > 0) {
        const activeStock = this.$store.getters['CatalogConfigurableProduct/virtualProducts'].filter(p => p[`${this.optionData['code']}_option_id`] === parseInt(e.target.value));
        if(activeStock.length) {
          await this.$store.dispatch('CatalogCategoryProduct/setSwStock', activeStock[0]['sw_stock']);
        }
      }
    }

    private async getProductOptions(): Promise<void> {
      return await this.$store.dispatch('CatalogConfigurableProduct/getAttributeOptionsByCode', this.optionData['code']).then(r => this.setAttributeData(r));
    }

    private get productFinalPrice(): number {
      return this.$store.getters['CatalogProduct/totalPrices'].totalPriceInclTax;
    }

    private get showAdditionalPrice(): boolean {
      return this.$store.getters['CatalogConfigurableProduct/availableAttributes'].length === (this.step + 1);
    }


    private setAttributeData(attributeData): void {
      if (this.attributeData.length === 1) {
        this.hasSingleOption = true;
        this.selectedValue = this.attributeData[0].id;
        this.$store.dispatch('CatalogConfigurableProduct/setSelectedOption', {attributeId: this.optionData['id'], attributeCode: this.optionData['code'], selectedValue: this.attributeData[0].id});
        this.$store.dispatch('CatalogConfigurableProduct/updateStep', (this.step + 1));
      }
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'CatalogConfigurableProduct/UPDATE_CURRENT_STEP') {
          if (this.step >= state.CatalogConfigurableProduct.step) {
            this.selectedValue = '';
            this.getProductOptions();
          }
        }
      });

      const optionIdField = `${this.optionData['code']}_option_id`;
      const products = this.$store.getters['CatalogConfigurableProduct/selectedProducts'] || [];

      this.attributeData = this.attributeData.map(
        (attributeOption) => {
          // Prefer option-id match (new Solr shape); fall back to label grouping (legacy).
          const byOptionId = products.find((product) =>
            Number(product[optionIdField]) === Number(attributeOption.id)
          );
          if (byOptionId) {
            attributeOption['price'] = byOptionId['final_price_incl_tax'];
            attributeOption['in_stock'] = byOptionId['in_stock'];
            return attributeOption;
          }

          Object.keys(attributeData).filter(
            (productData) => {
              return productData == attributeOption.label;
            }
          ).forEach((product) => {
            attributeOption['price'] = attributeData[product][0]['final_price_incl_tax'];
            attributeOption['in_stock'] = attributeData[product][0]['in_stock'];
          });

          return attributeOption;
        }
      )
    }

    private created() {
      this.attributeData = this.optionData['options'].map(
        (option) => {
          option['in_stock'] = false;
          option['price'] = 0;
          return option;
        }
      );

      this.getProductOptions();
    }

    @Watch('selectedValue')
    SetProductSku(nv) {
      this.$store.dispatch('CatalogCategoryProduct/setSelectedSku', nv);
    }
  }
</script>
